// Sidebar sections + expense categories metadata

export const SECTIONS = [
  { id: 'prehlad',    path: '/',           label: 'Prehľad',     color: 'green',  icon: 'gauge'  },
  { id: 'faktury',    path: '/faktury',    label: 'Faktúry',     color: 'blue',   icon: 'doc'    },
  { id: 'klienti',    path: '/klienti',    label: 'Klienti',     color: 'pink',   icon: 'users'  },
  { id: 'vydavky',    path: '/vydavky',    label: 'Výdavky',     color: 'orange', icon: 'receipt'},
  { id: 'nastavenia', path: '/nastavenia', label: 'Nastavenia',  color: 'gray',   icon: 'gear'   },
];

export const CATEGORIES = {
  food:      { label: 'Strava',        color: 'red',    icon: 'food'     },
  fuel:      { label: 'Pohonné hmoty', color: 'orange', icon: 'fuel'     },
  software:  { label: 'Softvér',       color: 'indigo', icon: 'software' },
  hardware:  { label: 'Hardvér',       color: 'gray',   icon: 'hardware' },
  marketing: { label: 'Marketing',     color: 'pink',   icon: 'marketing'},
  office:    { label: 'Kancelária',    color: 'yellow', icon: 'office'   },
  services:  { label: 'Služby',        color: 'teal',   icon: 'services' },
  other:     { label: 'Ostatné',       color: 'gray',   icon: 'other'    },
};

export const CATEGORY_KEYS = Object.keys(CATEGORIES);

export const STATUS_LABELS = {
  draft:     'Koncept',
  issued:    'Vystavená',
  paid:      'Zaplatená',
  overdue:   'Po splatnosti',
  cancelled: 'Zrušená',
};

export const DPH_RATES = [0, 10, 20, 23];
